import { render, staticRenderFns } from "./AppletShow.vue?vue&type=template&id=02230233&scoped=true"
import script from "./AppletShow.vue?vue&type=script&lang=js"
export * from "./AppletShow.vue?vue&type=script&lang=js"
import style0 from "./AppletShow.vue?vue&type=style&index=0&id=02230233&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02230233",
  null
  
)

export default component.exports